import type { User as SBUser } from 'sendbird-calls';

import type {
  StatefulDirectCall,
  AudioInputDeviceInfo,
  AudioOutputDeviceInfo,
  VideoInputDeviceInfo,
  StatefulRoom,
} from './types';

/** Types */
export type State = {
  user: SBUser;
  calls: StatefulDirectCall[];
  rooms: StatefulRoom[];
  audioInputDeviceInfo: AudioInputDeviceInfo;
  audioOutputDeviceInfo: AudioOutputDeviceInfo;
  videoInputDeviceInfo: VideoInputDeviceInfo;
};

/** State */
export const initialState: State = {
  user: {} as SBUser,
  calls: [],
  rooms: [],
  audioInputDeviceInfo: { current: undefined, available: [] },
  audioOutputDeviceInfo: { current: undefined, available: [] },
  videoInputDeviceInfo: { current: undefined, available: [] },
};
